import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-update-leap-reminder',
	templateUrl: './update-leap-reminder.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class UpdateLeapReminderComponent {}
